<template lang="pug">
#base-header-pre-analise
    .view-container
        .base-container
            .base-title-container
                h1.base__title
                    i.voltar.mdi.mdi-arrow-left-thick(
                        v-if='voltarPara',
                        @click='irParaRota(voltarPara)'
                    )
                    | {{ titulo }}
                .base__breadcrumb(v-if='breadcrumb')
                    el-breadcrumb(separator='.')
                        el-breadcrumb-item(
                            v-for='(sub, index) in breadcrumb',
                            :key='index'
                        )
                            span.link-breadcrumb(@click='irParaRota(sub.rota)')
                                | {{ sub.nome }}
            .base-header-historico-container
                .base-header-historico-inner
                    .base-header-historico-labels
                        .base-header-historico-labels-valores
                            span.base-header-historico-texto
                                | {{ $t('mensagens.preAnaliseCredito.consultas') }}
                            span.base-header-historico-totalizadores
                                | {{ totalizadores.totalConsultas }}
                        .base-header-historico-labels-valores
                            span
                        .base-header-historico-labels-valores
                            span.base-header-historico-texto
                                | {{ $t('mensagens.preAnaliseCredito.consultasNoMes') }}
                            span.base-header-historico-totalizadores
                                | {{ totalizadores.totalConsultasNoMes }}
                        .base-header-historico-labels-valores
                            span
                        .base-header-historico-labels-valores
                            span.base-header-historico-texto
                                | {{ $t('mensagens.preAnaliseCredito.creditosConsumidosMes') }}
                            span.base-header-historico-totalizadores
                                | {{ totalizadores.totalCreditoConsumidoMes }}
                    .base-header-historico-detalhar-btn(
                        @click='abrirModalVistualizarTotalizadoresConsultas'
                    )
                        span.color-inforacao {{ $t('mensagens.preAnaliseCredito.detalhar') }}
                            i.el-icon-right.color-inforacao
</template>

<script>
// IMPORTANTE !! Utilize a classe .view-container-base-header para complementar o uso desse componente.
export default {
    name: 'BaseHeaderPreAnalise',
    emits: ['btnHeaderClicado'],
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        voltarPara: {
            type: [Object, Boolean, String],
            default: () => null
        },
        breadcrumb: {
            type: Array,
            default: () => []
        },
        totalizadores: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        irParaRota(rota) {
            if (!rota) return;
            if (typeof rota === 'boolean' && rota) {
                this.$router.go(-1);
            } else if (typeof rota === 'string' && rota === 'emit') {
                this.$emit('voltarClicado');
            } else if (this.$route.name !== rota.route) {
                this.$router.push({ name: rota.route });
            }
        },
        emit() {
            this.$emit('btnHeaderClicado');
        },
        abrirModalVistualizarTotalizadoresConsultas() {
            this.$emit('abrirModalVistualizarTotalizadoresConsultas');
        }
    }
};
</script>

<style lang="scss">
#base-header-pre-analise {
    background: var(--white);
    box-shadow: 0 1px 3px 0 var(--block-shadow);
    .base-container {
        width: 100%;
        min-height: 87px;
        background: var(--white);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .base__title {
            display: flex;
            align-items: center;
            .voltar {
                cursor: pointer;
                font-size: 27px;
                color: #303133;
            }
            .voltar:hover {
                color: var(--secondary);
            }
        }
        .base-title-container {
            display: flex;
            flex-direction: column;
            .base__title {
                font-weight: 600;
            }
            .base__breadcrumb {
                margin-top: 8px;
                span.link-breadcrumb {
                    color: #1989fa;
                    text-decoration: underline;
                    cursor: pointer;
                }
                span.link-breadcrumb:hover {
                    color: var(--secondary);
                }
            }
        }
    }
    .button-outline {
        border-color: var(--secondary-two) !important;
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .base-button-container__btn {
        span {
            margin-left: 5px;
        }
    }
    .base-header-historico-container {
        margin: 8px 0px 8px 0px;
        padding: 0px 12px 2px 12px;
        width: 550px;
        height: 70px;
        border: 1px solid #cccccc;
        border-radius: 5px;
        font-family: 'Roboto', 'sans serif';

        .base-header-historico-inner {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: normal;
            align-content: normal;

            .base-header-historico-labels {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin-bottom: -9px;

                .base-header-historico-labels-valores {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: normal;
                    align-content: normal;

                    &:nth-child(2) {
                        width: 11%;

                        span {
                            border-right: 1px solid #c1c1c1;
                            height: 40px;
                        }
                    }

                    &:nth-child(4) {
                        width: 0%;

                        span {
                            border-right: 1px solid #c1c1c1;
                            height: 40px;
                        }
                    }

                    .base-header-historico-texto {
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 16px;
                        letter-spacing: 0em;
                        text-align: left;
                    }
                    .base-header-historico-totalizadores {
                        font-size: 18px;
                        font-weight: 500;
                        line-height: 21px;
                        letter-spacing: 0em;
                        text-align: left;
                        margin-top: 1px;
                        color: var(--primary);
                    }
                }
            }
            .base-header-historico-detalhar-btn {
                display: flex;
                justify-content: end;
            }
            .color-inforacao {
                font-weight: 500;
                display: flex;
                height: 17px;
                color: var(--blue);
                font-size: 14px;
                cursor: pointer;

                .el-icon-right.color-inforacao {
                    font-size: 16px;
                    &:before {
                        margin-top: 3px;
                    }
                }
                &:hover {
                    text-decoration: none;
                    color: #0256b1;
                }
            }
        }
    }
}
</style>
